import React from 'react';
import { Button } from '../../ui/Button';
import { ArrowRight, ArrowLeft, FileCheck, CheckCircle2 } from 'lucide-react';
interface DocumentsReviewData {
  idFile: File | null;
  regCertFile: File | null;
  addressProofFile: File | null;
}
interface DocumentsReviewScreenProps {
  data: DocumentsReviewData;
  onBack: () => void;
  onNext: () => void;
}
export function DocumentsReviewScreen({
  onNext,
  onBack,
  data
}: DocumentsReviewScreenProps) {
  return <div className="flex flex-col h-full animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-154">
      <div className="flex-1" data-id="element-155">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-156">
          Review Documents
        </h2>
        <p className="text-gray-600 mb-8" data-id="element-157">
          Please review your uploaded documents before submitting.
        </p>

        <div className="space-y-6 max-w-2xl" data-id="element-158">
          {/* Documents Section */}
          <div className="bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-159">
            <div className="bg-gray-50 px-4 py-3 border-b border-gray-200" data-id="element-160">
              <h3 className="font-medium text-gray-900 flex items-center" data-id="element-161">
                <FileCheck className="w-4 h-4 mr-2 text-gray-500" data-id="element-162" />
                Uploaded Documents
              </h3>
            </div>
            <div className="divide-y divide-gray-100" data-id="element-163">
              <ReviewItem label="Identification" value={data.idFile?.name} data-id="element-164" />
              <ReviewItem label="Registration Certificate" value={data.regCertFile?.name} data-id="element-165" />
              <ReviewItem label="Proof of Address" value={data.addressProofFile?.name} data-id="element-166" />
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 flex justify-between items-center" data-id="element-167">
        <Button variant="secondary" onClick={onBack} data-id="element-168">
          <ArrowLeft className="mr-2 h-4 w-4" data-id="element-169" /> Back
        </Button>
        <Button onClick={onNext} data-id="element-170">
          Submit Documents <ArrowRight className="ml-2 h-4 w-4" data-id="element-171" />
        </Button>
      </div>
    </div>;
}
function ReviewItem({
  label,
  value
}: {
  label: string;
  value?: string;
}) {
  return <div className="px-4 py-3 flex justify-between items-center" data-id="element-172">
      <span className="text-sm text-gray-500" data-id="element-173">{label}</span>
      <div className="flex items-center" data-id="element-174">
        <span className="text-sm font-medium text-gray-900 mr-2" data-id="element-175">
          {value || 'Not provided'}
        </span>
        {value && <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-176" />}
      </div>
    </div>;
}